<template>
  <!--  批量单号导出  -->
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="exportRuleForm"
      :model="exportRuleForm"
      class="demo-exportRuleForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="orderNumType"
      >
        <el-select v-model="exportRuleForm.orderNumType" style="width: 80%">
          <!--运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
          <!--单号-->
          <el-option key="5" :label="$t('GlobalSetObj.ScanNumber')" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('orderCenterCont.PushNodes')"
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="trackNode"
      >
        <el-select v-model="exportRuleForm.trackNode" style="width: 80%">
          <el-option
            v-for="item in nodeList"
            :key="item.dictName"
            :label="item.dictDescribe"
            :value="item.dictName"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="">
        <template slot="label">
          <div>
            <span style="color: #f56c6c">*</span>
            <span>{{ $t('uploadFile.uploadFiles') }}</span>
          </div>
        </template>
        <el-button
          size="small" type="primary" @click="triggerFileInput"
        >{{ $t('customerManagements.clickUpload') }}
        </el-button>
        <div style="line-height: 25px">{{ $t('uploadFile.fileUploadRestrictions') }}</div>
        <input
          ref="referenceUpload"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          style="display: none"
          type="file"
          @change="uploadFile($event)"
        >
      </el-form-item>
      <div v-if="fileName" class="downLink">
        <div>{{ fileName }}</div>
        <div><i class="el-icon-error" @click="delFile" /></div>
      </div>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="primary" @click="comfireBtchExport"
      >{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { exportTrackPushLogByFile } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  props: {
    nodeList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      dialogVisibleExport: false,
      fileName: '',
      fileData: null,
      exportRuleForm: {
        orderNumType: '1',
        trackNode: ''
      }
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '190px' : '120px'
      };
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.referenceUpload.click();
    },
    // 上传文件
    uploadFile(e) {
      this.fileData = e.target.files[0];
      this.fileName = e.target.files[0].name;
    },
    // 删除文件
    delFile() {
      this.fileName = '';
      this.fileData = null;
    },
    // 批量导出
    clickBatchExport() {
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exportRuleForm.orderNumType = '1';
      this.exportRuleForm.trackNode = '';
      this.$refs.referenceUpload.value = '';
      this.fileName = '';
      this.fileData = null;
    },
    // 确定批量导出
    comfireBtchExport() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          // 如果有文件上传
          if (this.fileName) {
            formData.append('trackNode', this.exportRuleForm.trackNode);
            formData.append('file', this.fileData, this.fileName);
            formData.append('orderNumType', this.exportRuleForm.orderNumType);
          } else {
            this.$message.error(this.$t('routes.pleaseUploadFile'));
            return;
          }
          this.dialogVisibleExport = false;
          exportTrackPushLogByFile(formData).then((res) => {
            if (res.code === 200) {
              goResourceTaskList();
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}
</style>
